import React, { useEffect, useRef, createElement } from 'react';
export function ApplicationFormSection() {
  const typeformContainerRef = useRef<HTMLDivElement>(null);
  const scriptLoaded = useRef(false);
  useEffect(() => {
    // Only load the script once
    if (scriptLoaded.current) return;
    // Create and load the Typeform script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    script.onload = () => {
      scriptLoaded.current = true;
      console.log('Typeform script loaded successfully');
    };
    document.body.appendChild(script);
    // Cleanup function to remove the script when component unmounts
    return () => {
      // We don't actually remove the script on unmount as it might be needed by other components
      // and removing it could break the form if it's re-mounted
    };
  }, []);
  return <section id="application-form" className="py-20 bg-gradient-to-br from-purple-600 to-blue-600 text-white" data-id="element-114">
      <div className="container mx-auto px-4" data-id="element-115">
        <div className="max-w-5xl mx-auto relative" data-id="element-116">
          {/* Background elements for visual interest */}
          <div className="absolute -top-6 -left-6 w-20 h-20 bg-purple-400 bg-opacity-20 rounded-full blur-xl" data-id="element-117"></div>
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-blue-400 bg-opacity-20 rounded-full blur-xl" data-id="element-118"></div>
          {/* Floating elements */}
          <div className="absolute -top-10 right-10 bg-white/10 backdrop-blur-sm rounded-lg p-3 shadow-lg transform -rotate-3 border border-white/20 hidden md:block" data-id="element-119">
            <div className="flex items-center" data-id="element-120">
              <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center mr-3" data-id="element-121">
                <span className="text-lg" data-id="element-122">🔍</span>
              </div>
              <p className="text-sm font-medium" data-id="element-123">Limited spaces available</p>
            </div>
          </div>
          <div className="relative z-10 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-xl" data-id="element-124">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-125">
              {/* Left content */}
              <div className="w-full md:w-2/5" data-id="element-126">
                <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6 animate-pulse" data-id="element-127">
                  <span className="text-xl mr-2" data-id="element-128">📅</span>
                  <span className="font-medium" data-id="element-129">Starting September 2026</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-130">
                  Apply Now
                </h2>
                <p className="text-white/90 mb-6" data-id="element-131">
                  Join us in shaping the future of maths education in the UK.
                </p>
                <p className="text-white/90 mb-6" data-id="element-132">
                  Complete the short form to express your interest or email
                  Harriet directly at{' '}
                  <a href="mailto:harriet.walters@eedi.com" className="underline hover:text-white" data-id="element-133">
                    harriet.walters@eedi.com
                  </a>
                </p>
                {/* Application process */}
                <div className="mb-6 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-134">
                  <h3 className="font-bold text-lg mb-3" data-id="element-135">
                    Simple Application Process
                  </h3>
                  <div className="space-y-4" data-id="element-136">
                    <div className="flex items-center gap-3" data-id="element-137">
                      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg shrink-0" data-id="element-138">
                        1
                      </div>
                      <div data-id="element-139">
                        <p className="font-medium" data-id="element-140">Apply in 2 minutes</p>
                        <p className="text-sm text-white/70" data-id="element-141">
                          Complete the short form
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-142">
                      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg shrink-0" data-id="element-143">
                        2
                      </div>
                      <div data-id="element-144">
                        <p className="font-medium" data-id="element-145">Initial screening call</p>
                        <p className="text-sm text-white/70" data-id="element-146">
                          Discuss your school's needs
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-147">
                      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-lg shrink-0" data-id="element-148">
                        3
                      </div>
                      <div data-id="element-149">
                        <p className="font-medium" data-id="element-150">Begin partnership</p>
                        <p className="text-sm text-white/70" data-id="element-151">
                          Get ready for September 2026
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Right content - form */}
              <div className="w-full md:w-3/5 bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl" data-id="element-152">
                <div className="p-6 border-b border-gray-200" data-id="element-153">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-154">
                    Research Study Application
                  </h3>
                  <p className="text-gray-600" data-id="element-155">
                    Register your school's interest in the KS3 maths RCT
                  </p>
                </div>
                <div className="p-6 min-h-[400px] bg-gray-50" ref={typeformContainerRef} data-id="element-156">
                  {/* Typeform embed */}
                  <div data-tf-live="01KBN247TTVE6HH382EBHC2PX2" data-id="element-157"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}